import http from 'hub-http/clients/apiClient';
const BASE_URL = 'web-interactives/v1/cos-interactives';
export const getInteractiveDetails = interactiveId => {
  return http.get(`${BASE_URL}/${interactiveId}`);
};
export const updateInteractiveName = (interactiveId, name) => {
  return http.put(`${BASE_URL}/${interactiveId}`, {
    data: {
      name
    }
  });
};